define(function(require,exports,module){
    var UNDEFINED;

    var PitchRaster = require( './PitchRaster' ),
        PitchShader = require( './PitchShader' ),
        PitchVector = require( './PitchVector'),
        floater = require( "../helpers/floatsMagotes" );

    function Pitch(pitch,renderer){
        var stats   = pitch,
            details = stats.details,
            coords;
        var scalers = renderer.scalers;
        this.pitch=pitch;
        this.isPitch = !!pitch.isPitch;
        this.details = details;
        this.isBall = details && details.isBall;
        this.isStrike = details && details.isStrike;
        this.isInPlay = details && details.isInPlay;
        this.code = details && details.code;
        this.stats = stats;
        this.startSpeed = stats.pitchData.startSpeed;
        this.endSpeed = stats.pitchData.endSpeed;
        this.breaks = stats.pitchData.breakAngle || (stats.pitchData.breaks && stats.pitchData.breaks.breakAngle);
        this.type = (details.type && details.type.code) || (pitch.type && pitch.type.code) || "";
        this.displayName = (details.type && details.type.description) || "";
        this.coords = coords = floater(stats.pitchData.coordinates);
        this.szTop = stats.pitchData.strikeZoneTop;
        this.szBot = stats.pitchData.strikeZoneBottom;
        this.szWidth = (stats.pitchData.strikeZoneWidth / scalers.foot) || scalers.homePlateWidth;
        this.szDepth = (stats.pitchData.strikeZoneDepth / scalers.foot) || scalers.homePlateFrontY;
        this.num = pitch.pitchNumber || pitch.index;
        this.renderer=renderer;
        this.is3DPitch = !!(coords.y0 && coords.x0 && coords.z0);
        this.raster = new PitchRaster(this,renderer);
        this.shader = new PitchShader(this,renderer);
        this.vector = new PitchVector(this,renderer);
        this.spinRate = stats && stats.pitchData && stats.pitchData.spinRate || stats && stats.pitchData && stats.pitchData.breaks && stats.pitchData.breaks.spinRate;
        this.result = details && details.description;
    }


    Pitch.prototype.getPitchColor = function(){
        return this.shader.fill;
    };

    Pitch.prototype.getPitchBallColor = function(){
        return this.shader.ball;
    };

    Pitch.prototype.getArrayOfPoints = function (numberOfPoints) {
        var scalers=this.renderer.scalers,
            timeInterval = ((this.raster.timeAtYPosition(this.szDepth)) / numberOfPoints),
            pointOnScreen,
            boundPoint,
            points = [],
            currentZ,
            step = 1,
            time,
            color = this.shader.color,
            ballColor = this.shader.fill,
            bounds = scalers.bounds;

        var lastPointOnScreen;
        var firstPointOnScreen;

        //tack on an extra for rendering the ball
        for (; step <= numberOfPoints; step++) {

            time = step * timeInterval;
            /**
             * Calc x,y,z in pitchFX coords at time and convert to screen space
             * NOTE: Swap y and z and negate y to match CoreAnimation coordinate system
             * TODO: see if this is true for canvas too...
             */
            pointOnScreen = this.raster.points3D(time,step,numberOfPoints);

            if (pointOnScreen===null) {
                // Pitch has been clipped, end the path here
                break;
            }
            points.push(pointOnScreen);

            if (scalers.perspective === 'pitcher') {
                lastPointOnScreen = points[0];
                firstPointOnScreen = pointOnScreen;

            } else {
                lastPointOnScreen = pointOnScreen;
                firstPointOnScreen = points[0];
            }
        }

        if(firstPointOnScreen && lastPointOnScreen) {
            this.gradient = this.shader.getGradient(firstPointOnScreen[0], firstPointOnScreen[1], lastPointOnScreen[0], lastPointOnScreen[1]);
        }

        return points;
    };

    return Pitch;
});
